var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-container',{staticClass:"mt-5"},[_c('b-row',[_c('b-col',[_c('h1',[_vm._v("\n                    This invite is invalid.\n                ")])])],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }